import React, { useState, useEffect } from 'react';
import {
  Box, Flex, Text, Modal, ModalOverlay,
  ModalContent, ModalHeader, ModalBody, ModalCloseButton, Link, Button, Spacer, IconButton, useBreakpointValue
} from '@chakra-ui/react';
import { ChatIcon,ArrowBackIcon } from '@chakra-ui/icons';
import { FaClock, FaBriefcase, FaLink, FaCircle } from 'react-icons/fa';
import axios from 'axios';
import Chat from '../../components/global/chat';
import { useNavigate } from 'react-router-dom';
import InvoiceDetails from '../../components/global/invoiceDetails';

const ClockInModal = ({ isOpen, onClose, jobId, jobTitle, ...props }) => {
  const [isClockedIn, setIsClockedIn] = useState(false);
  const [clockInTime, setClockInTime] = useState(null);
  const [clockOutTime, setClockOutTime] = useState(null);
  const [isClockInDisabled, setIsClockInDisabled] = useState(true);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [applicantName, setApplicantName] = useState('');
  const [applicantAddress, setApplicantAddress] = useState('');
  const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);
  const [applicantEmail, setApplicantEmail] = useState('');
  const [userCountry, setUserCountry] = useState('');

  const navigate = useNavigate();

   // Helper Functions
   const isToday = (date) => {
    const today = new Date();
    return date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();
  };

  const isCurrentOrAfterStartTime = (startTime) => {
    const now = new Date();
    const [startHour, startMinute] = startTime.split(':').map(Number);
    return now.getHours() > startHour || (now.getHours() === startHour && now.getMinutes() >= startMinute);
  };
  const chatButtonPosition = useBreakpointValue({
    base: { top: '10px', right: '20px' }, // Small screens
    md: { top: '50px', left: '300px' },   // Medium screens
    lg: { top: '50px', left: '500px' },   // Large screens
    xl: { top: '50px', left: '700px' },   // Extra-large screens
  });
  // Check if the Clock In button should be enabled
  useEffect(() => {
    const startDate = new Date(props.jobStartDate);
    if (isToday(startDate) && isCurrentOrAfterStartTime(props.jobStartTime)) {
      setIsClockInDisabled(false);
    } else {
      setIsClockInDisabled(true);
    }
  }, [props.jobStartDate, props.jobStartTime]);


  useEffect(() => {
    if (isOpen) {
      fetchClockStatus();
    }
  }, [isOpen]);

  useEffect(() => {
    const fetchApplicantDetails = async () => {
      const ticketToken = sessionStorage.getItem('ticketToken');
      try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/applicant/get-applicant-details`, {
          headers: {
            Authorization: `Bearer ${ticketToken}`
          }
        });

        if (response.status === 200) {
          setApplicantName(response.data.data.FullName);
          setApplicantAddress(response.data.data.address.contact_address);
          setApplicantEmail(response.data.data.email);
          setUserCountry(response.data.data.country || '');
        }
      } catch (error) {
        console.error("Error fetching applicant details:", error);
      }
    };

    fetchApplicantDetails();
  }, []);

  

  const fetchClockStatus = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/applicant/clock-status`, {
        params: { jobId },
        headers: {
          Authorization: `Bearer ${ticketToken}`
        }
      });

      if (response.status === 200) {
        const { clockInTime, clockOutTime } = response.data.data;
        setClockInTime(clockInTime);
        setClockOutTime(clockOutTime);
        setIsClockedIn(!!clockInTime && !clockOutTime);


        console.log("....////////////////////.............mail",applicantEmail)
      }
    } catch (error) {
      console.error("Error fetching clock status:", error);
    }
  };

  const handleChatClick = () => {
    setIsChatOpen(true);
  };

  const handleBackClick = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    const url = `${process.env.REACT_APP_SERVER_URL}/chat/update-chat-close-time`;
    await axios.post(url,{},
      {
      headers: {
        Authorization: `Bearer ${ticketToken}`
      }
    });
    setIsChatOpen(false);
  };

  const handleClockToggle = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    const url = `${process.env.REACT_APP_SERVER_URL}/applicant/clock`;

    try {
      const response = await axios.post(
        url,
        { jobId },
        {
          headers: {
            Authorization: `Bearer ${ticketToken}`
          }
        }
      );

      if (response.status === 200) {
        const { action, data } = response.data;
        if (action === "clocked in") {
          setClockInTime(data.clockInTime);
          setIsClockedIn(true);
        } else if (action === "clocked out") {
          setClockOutTime(data.clockOutTime);
          setIsClockedIn(false);
        }
      }
    } catch (error) {
      console.error("Error toggling clock:", error);
    }
  };

  const handleCloseClick = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    const url = `${process.env.REACT_APP_SERVER_URL}/chat/update-chat-close-time`;
    await axios.post(url,
      {},
      {
      headers: {
        Authorization: `Bearer ${ticketToken}`
      }
    });
    setIsChatOpen(false);
  }
  
    // console.log(".................",jobTitle)
  const handleInvoiceClick = () => {
    setIsInvoiceOpen(!isInvoiceOpen);
  };

  const calculateTotalHours = () => {
    if (!clockInTime || !clockOutTime) {
      console.log('Missing clock times:', { clockInTime, clockOutTime });
      return 0;
    }

    const formatDateTime = (dateTimeStr) => {
      const date = new Date(dateTimeStr);
      return {
        date: date.toLocaleDateString('en-US', { 
          year: 'numeric', 
          month: 'short', 
          day: 'numeric' 
        }),
        time: date.toLocaleTimeString('en-US', { 
          hour: '2-digit', 
          minute: '2-digit',
          hour12: true 
        })
      };
    };

    const clockInFormatted = formatDateTime(clockInTime);
    const clockOutFormatted = formatDateTime(clockOutTime);

    console.log('Formatted Clock In:', `${clockInFormatted.date} ${clockInFormatted.time}`);
    console.log('Formatted Clock Out:', `${clockOutFormatted.date} ${clockOutFormatted.time}`);

    const startDate = new Date(clockInTime);
    const endDate = new Date(clockOutTime);

    const diffTime = Math.abs(endDate - startDate);
    console.log('Time Difference (ms):', diffTime);

    const diffHours = diffTime / (1000 * 60 * 60); // Convert milliseconds to hours
    console.log('Final Hours Difference:', diffHours);

    return diffHours;
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={{ base: "full", md: "lg" }} isCentered>
      <ModalOverlay />
      <ModalContent
        maxW={{ base: "100%", sm: "90%", md: "70%", lg: "50%" }}
        h={{ base: "100vh", md: "90vh" }}
        mx={{ base: 0, md: "auto" }}
        my={{ base: 0, md: "5vh" }}
        borderRadius={{ base: 0, md: "lg" }}
      >
        <ModalHeader>
          <Flex 
            direction={{ base: "column", md: "row" }} 
            align={{ base: "flex-start", md: "center" }}
            spacing={2}
          >
            {isChatOpen && (
              <IconButton
                icon={<ArrowBackIcon />}
                onClick={handleBackClick}
                aria-label="Back to Clock In"
                variant="ghost"
                colorScheme="blue"
                mr={2}
              />
            )}
            <Text fontWeight="bold" fontSize={{ base: "lg", md: "xl" }}>{jobTitle}</Text>
          </Flex>
          <Flex 
            direction={{ base: "column", md: "row" }}
            align={{ base: "flex-start", md: "center" }}
            mt={2}
          >
            <Link href={props.shareLink} isExternal display="flex" alignItems="center" color="blue.500">
              <Text fontSize={{ base: "sm", md: "md" }} color="blue.500">{props.company}</Text>
              <Text fontSize={{ base: "sm", md: "md" }} color="blue.500">• {props.location}</Text>
              <Box as={FaLink} boxSize={{ base: 3, md: 4 }} ml={2} color="blue.500" />
            </Link>
          </Flex>
        </ModalHeader>
        <ModalCloseButton 
          color="black" 
          onClick={handleCloseClick}
          _hover={{ color: 'white', bg: 'blue.500' }} 
        />
        <ModalBody overflowY="auto" css={{
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'gray',
            borderRadius: '24px',
          },
        }}>
          {isChatOpen ? (
            <Box h="60vh"> {/* Adjusted chat height */}
              <Chat jobId={jobId} />
            </Box>
          ) : (
            <>

          <Flex align="center" mb={4}>
            <FaClock style={{ marginRight: '8px' }} />
            <Text>{props.jobDates}</Text>
          </Flex>
          <Flex align="center" mb={4}>
            <FaBriefcase style={{ marginRight: '8px' }} />
            <Text>{props.salary}</Text>
            <Spacer />
            {props.category !== 'Completed' ? (
              <Flex align="center" marginRight={4}>
                <Button
                  leftIcon={<ChatIcon />}
                  position={chatButtonPosition}
                  size="md"
                  colorScheme="blue"
                  onClick={handleChatClick}
                  aria-label="Chat with applicants"
                  ml={4} // Margin to separate from the title
                >
                  Chat
                </Button>
              </Flex>
            ) : (
              <Flex align="center" marginRight={4}>
                <Button
                  leftIcon={<FaLink />}
                  size="md"
                  colorScheme="green"
                  onClick={handleInvoiceClick}
                  aria-label="View Invoice"
                  ml={4} // Margin to separate from the title
                >
                  View Timesheet
                </Button>
              </Flex>
            )}
          </Flex>

          <Box bg="white" p={6} borderRadius="md" boxShadow="lg" mb={4} position="relative" height="150px">
            <Text fontWeight="bold" fontSize="lg" mb={2}>Clock In</Text>
            {clockInTime && (
              <Flex align="center" mb={2} fontSize="sm">
                <Box as={FaCircle} color="teal" boxSize={2.5} mr={2} mt={0.5} />
                <Text color="teal">
                  Clock In: {new Date(clockInTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
                </Text>
              </Flex>
            )}
            {clockOutTime && (
              <Flex align="center" mb={2} fontSize="sm">
                <Box as={FaCircle} color="teal" boxSize={2.5} mr={2} mt={0.5} />
                <Text color="teal">
                  Clock Out: {new Date(clockOutTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
                </Text>
              </Flex>
            )}
            {!clockInTime && (
              <Text mb={2} fontSize="sm">
                You haven't clocked in yet.
              </Text>
            )}
            <Box
              position="absolute"
              right={4}
              top="50%"
              transform="translateY(-50%)"
              borderRadius="full"
              border="1px solid teal"
              p="4px"
            >
              <Button
                colorScheme="teal"
                size="lg"
                borderRadius="full"
                width="100px"
                height="100px"
                fontWeight="normal"
                fontSize="md"
                onClick={handleClockToggle}
                isDisabled={isClockInDisabled || clockOutTime !== null}
              >
                {isClockedIn ? 'Clock Out' : 'Clock In'}
              </Button>
            </Box>
          </Box>

          <Text fontWeight="bold" mb={2}>Description</Text>
          <Text mb={4}>{props.description}</Text>

          <Text fontWeight="bold" mb={2}>Location</Text>
          <Text mb={4}>{props.location}</Text>


          <Text fontWeight="bold" mb={2}>Required Skills</Text>
          <Box
                      
                    bg="gray.100"
                    p={2}
                    m={1}
                    borderRadius="md"
                    boxShadow="sm"
                  >
                    {props.skills}
                  </Box>


          
          
            </>
          )}
        </ModalBody>
      </ModalContent>

      {/* InvoiceDetails Modal */}
      <Modal isOpen={isInvoiceOpen} onClose={handleInvoiceClick} size="lg" isCentered>
        <ModalOverlay />
        <ModalContent
          maxW="50%"
        >
          {/* <ModalHeader>Invoice</ModalHeader> */}
          <ModalCloseButton />
          <ModalBody>
            <InvoiceDetails 
            jobId={jobId}
              applicantName={applicantName} 
              applicantAddress={applicantAddress}
              applicantEmail={applicantEmail}
              providerName={props.company} 
              salary={props.salary} 
              settlementPeriod={props.settlementPeriod}
              currencyType={props.currencyType} 
              jobStartTime={props.jobStartTime} 
              jobTitle={jobTitle} 
              jobEndTime={props.jobEndTime} 
              jobDates={props.jobDates} 
              jobStartDate={props.jobStartDate} 
              jobEndDate={props.jobEndDate} 
              totalHours={calculateTotalHours().toFixed(2)} 
              totalSalary={(calculateTotalHours() * parseFloat(props.salary.replace(/[^0-9.-]+/g, ""))).toFixed(2)} 
              isFromClockinModal={true}
              isApplicant = {true}
              userCountry={userCountry}
              onClose={handleInvoiceClick}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Modal>
  );
};

export default ClockInModal;